// Configurações de CORS para comunicação entre serviços
import { PRODUCTION_CONFIG, isProduction } from './production';

export const CORS_CONFIG = {
  // Headers padrão para requisições
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Headers para requisições CORS
  CORS_HEADERS: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',
    'Access-Control-Allow-Credentials': 'true',
  },
  
  // Configurações de fetch para CORS
  FETCH_CONFIG: {
    mode: 'cors' as RequestMode,
    credentials: 'include' as RequestCredentials,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }
} as const;

// Função para criar configuração de fetch com CORS
export const createFetchConfig = (options: RequestInit = {}): RequestInit => {
  return {
    ...CORS_CONFIG.FETCH_CONFIG,
    ...options,
    headers: {
      ...CORS_CONFIG.FETCH_CONFIG.headers,
      ...options.headers,
    }
  };
};

// Função para fazer requisições com tratamento de CORS
export const corsRequest = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const config = createFetchConfig(options);
  
  try {
    const response = await fetch(url, config);
    return response;
  } catch (error) {
    // Se falhar com CORS, tenta sem credentials
    if (error instanceof TypeError && error.message.includes('CORS')) {
      const fallbackConfig = {
        ...config,
        credentials: 'omit' as RequestCredentials,
      };
      return fetch(url, fallbackConfig);
    }
    throw error;
  }
};

// Função para verificar se uma URL é cross-origin
export const isCrossOrigin = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.origin !== window.location.origin;
  } catch {
    return false;
  }
};

// Função para obter URLs permitidas baseadas no ambiente
export const getAllowedOrigins = (): string[] => {
  if (isProduction()) {
    return [...PRODUCTION_CONFIG.CORS_ORIGINS];
  }
  
  // Desenvolvimento - permite localhost em várias portas
  return [
    'http://localhost:3000',
    'http://localhost:3001',
    'http://127.0.0.1:3000',
    'http://127.0.0.1:3001',
  ];
};